export default {
  en: {
    accept_all: "Accept all",
    accept_selected: "Accept selected",
    decline_all: "Decline all",
    this_website_uses_cookies: "This website uses cookies",
    configure_cookies: "Configure cookies",
    technical_cookies: "Technical cookies (required)",
    technical_cookies_description:
      "Technical cookies are necessary for the website to function properly. They are used to save your settings and preferences.",
    marketing_cookies: "Marketing cookies",
    marketing_cookies_description:
      "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
    analytics_cookies: "Analytics cookies",
    analytics_cookies_description:
      "Analytics cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.",
    privacy_policy: "Privacy Policy",
  },
  de: {
    accept_all: "Alle akzeptieren",
    accept_selected: "Ausgewählte akzeptieren",
    decline_all: "Alle ablehnen",
    this_website_uses_cookies: "Diese Website verwendet Cookies",
    configure_cookies: "Cookies konfigurieren",
    technical_cookies: "Technische Cookies (erforderlich)",
    technical_cookies_description:
      "Technische Cookies sind für das Funktionieren der Website erforderlich. Sie werden verwendet, um Ihre Einstellungen und Präferenzen zu speichern.",
    marketing_cookies: "Marketing-Cookies",
    marketing_cookies_description:
      "Marketing-Cookies werden verwendet, um Besucher über Websites hinweg zu verfolgen. Die Absicht ist es, Anzeigen zu zeigen, die für den einzelnen Benutzer relevant und ansprechend sind und damit für Publisher und Drittanbieter-Werbetreibende wertvoller sind.",
    analytics_cookies: "Analyse-Cookies",
    analytics_cookies_description:
      "Analyse-Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
    privacy_policy: "Datenschutzerklärung",
  },
};
